export const interleave = <T, U = T>(
  array: T[],
  elementToInterleave: U,
): (T | U)[] =>
  array
    .flatMap((arrayElement) => [arrayElement, elementToInterleave])
    .slice(0, -1);
